import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Icon } from '@breezeway/brzw-components';
import { TASK_READY_TYPE_STATUS } from '../../utils/task';

import './status_icon.scss';

const CLASS_NAME = 'status-icon';

const getReadyStatusColor = code => {
  switch (code) {
    case TASK_READY_TYPE_STATUS.INSPECTED:
    case TASK_READY_TYPE_STATUS.CLEANED:
    case TASK_READY_TYPE_STATUS.CLEANING:
    case TASK_READY_TYPE_STATUS.INSPECTING:
      return 'green';

    case TASK_READY_TYPE_STATUS.READY:
      return 'dark-green';

    case TASK_READY_TYPE_STATUS.OCCUPIED:
      return 'gray';

    case TASK_READY_TYPE_STATUS.BLOCKED:
      return 'red';

    case TASK_READY_TYPE_STATUS.DIRTY:
      return 'orange';

    default:
      return null;
  }
};

const StatusIcon = props => {
  const { code, className, iconName } = props;

  return (
    <div
      className={classnames(CLASS_NAME, className, {
        [`${CLASS_NAME}--color-${getReadyStatusColor(code)}`]: code,
      })}
    >
      <Icon iconName={iconName} className={`${CLASS_NAME}__icon`} />
    </div>
  );
};

StatusIcon.defaultProps = {
  iconName: 'medium-filled',
};

StatusIcon.propTypes = {
  className: PropTypes.string,
  code: PropTypes.string,
  iconName: PropTypes.string,
};

export default StatusIcon;
